/* globals alert, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    _ = require('lodash'),
    //
    Unit = require('../models/unit'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    EOL = null;

module.exports = Backbone.Collection.extend({
    model: Unit,
    comparator: function (a, b) {
        if (!a.id || !b.id) {
            // a unit with no id is being created so put it at the top of the list
            return !a.id ? -1 : 1;
        } else if (a.attributes.vacancies !== b.attributes.vacancies) {
            return (b.attributes.vacancies - a.attributes.vacancies);
        } else {
            return a.attributes.name.localeCompare(b.attributes.name);
        }
    },
    create: function (serializedValues) {
        const processedValues = formProcessor(serializedValues, 'units');
        let unit;
        processedValues.organizationId = this.organizationId;
        unit = new Unit(processedValues);
        unit.save(null, {
            success: _.bind(function (model, response, options) {
                this.add(model);
            }, this),
            error: function (model, xhr, options) {
                alert('Unable to create unit\n(' + xhr.responseJSON.message + ')');
            }
        });
    },
    initialize: function (models, options) {
        this.fetch({
            method: 'GET',
            reset: true,
            url: configuration.apiUrlBase + 'programUnits/' + options.programId // + (this.options.programId || 1), // @acavan!
        });
    }
});
